import styles from './LoadingCard.module.scss'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'
import { Card } from '@boltenergy-be/design-system'

const LoadingCard = () => (
  <Card className={styles['card-loading']}>
    <LoadingSkeleton>
      <LoadingSkeleton.Title />
      <LoadingSkeleton.Paragraph lines={3} />
    </LoadingSkeleton>
  </Card>
)

export default LoadingCard
